export interface TimepickerConfig {
  /** Row height in px. Affects scroll math. Default: 48 */
  itemHeight?: number;
  /** Number of visible rows in the scroll window. Default: 5 */
  visibleItems?: number;
  /** Font size (px) of the selected center item. Default: 22 */
  fontSizeSelected?: number;
  /** Font size (px) of items ±1 from center. Default: 18 */
  fontSizeNear?: number;
  /** Font size (px) of items ±2+ from center. Default: 15 */
  fontSizeFar?: number;
  /** Opacity of items ±1 from center. Default: 0.45 */
  opacityNear?: number;
  /** Opacity of items ±2 from center. Default: 0.2 */
  opacityFar?: number;
  /** Opacity of items ±3+ from center. Default: 0.08 */
  opacityHidden?: number;
}

export const DEFAULT_CONFIG: Required<TimepickerConfig> = {
  itemHeight: 48,
  visibleItems: 5,
  fontSizeSelected: 22,
  fontSizeNear: 18,
  fontSizeFar: 15,
  opacityNear: 0.45,
  opacityFar: 0.2,
  opacityHidden: 0.08,
};
